<template>
    <v-container id="wishlist-component" :class="$mobile ? 'px-0' : ''">
        <v-row>
            <v-spacer></v-spacer>
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 10" :class="$mobile ? 'px-0' : ''">
                <v-row class="d-flex align-end mb-4" no-gutters>
                    <v-col style="min-width: 100px" v-if="!$vuetify.breakpoint.mobile" class="d-flex align-center mr-8 shrink">
                        <icon-base height="50" width="25" viewBox="0 0 60 80" icon-name="b" preserveAspectRatio="xMaxYMid meet">
                            <icon-b iconColor="rgb(213, 0, 0, 1)" />
                        </icon-base>
                        <span v-if="!$vuetify.breakpoint.mobile" class="text-h6 font-weight-light mt-4 ml-n1">
                            {{ name }}
                        </span>
                    </v-col>
                    <v-col :cols="$mobile ? 12 : 6" class="text--secondary">
                        <v-col v-if="$mobile" style="min-width: 100px" class="d-flex align-center mr-8 shrink">
                            <icon-base height="50" width="25" viewBox="0 0 60 80" icon-name="b" preserveAspectRatio="xMaxYMid meet">
                                <icon-b iconColor="rgb(213, 0, 0, 1)" />
                            </icon-base>
                            <span class="text-h6 font-weight-light mt-4 ml-n1">
                                {{ name }}
                            </span>
                            <v-spacer></v-spacer>
                            <v-chip v-if="$mobile && accountId" label outlined class="align-self-end">
                                <span class="font-weight-medium text-uppercase text-subtitle-1">{{ 'Your Total Gift' }}</span>
                                <div class="d-flex align-center text-h6" :class="$mobile ? '' : 'ml-4'">
                                    <icon-base height="25" width="25" viewBox="0 0 100 225" icon-name="near">
                                        <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                    </icon-base>
                                    <span class="ml-1 mr-2"><number style="color: #43a047" :from="0" :to="giftedTotal.near" :duration="7" easing="Power4.easeOut" /></span>
                                    ($<number style="color: #43a047" :from="0" :to="giftedTotal.usd" :duration="7" easing="Power4.easeOut" />)
                                </div>
                            </v-chip>
                        </v-col>
                        <span v-else class="text-uppercase text-h5" key="0">
                            {{ prompt }}
                        </span>
                        <sub v-if="!$mobile" class="d-flex mt-1 ml-4 flex-wrap font-italic">
                            {{ subprompt }}
                        </sub>
                        <span v-else class="d-flex mt-1 ml-4 flex-wrap font-italic">
                            {{ subprompt }}
                        </span>
                    </v-col>
                    <v-col class="d-flex align-center">
                        <v-card v-if="!$mobile && accountId" class="px-4" elevation="1">
                            <v-row>
                                <v-col>
                                    <span class="font-weight-medium text-uppercase text-subtitle-2 text-no-wrap">{{ 'Your Gift' }}</span>
                                    <div class="d-flex align-center text-h6" :class="$mobile ? '' : 'ml-4'">
                                        <icon-base height="25" width="25" viewBox="0 0 100 225" icon-name="near">
                                            <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                        </icon-base>
                                        <span class="ml-1 mr-2"><number style="color: #43a047" :from="0" :to="giftedThisWishlist.near" :duration="7" easing="Power4.easeOut" /></span>
                                        ($<number style="color: #43a047" :from="0" :to="giftedThisWishlist.usd" :duration="7" easing="Power4.easeOut" />)
                                    </div>
                                </v-col>
                                <v-col>
                                    <span class="font-weight-medium text-uppercase text-subtitle-2 text-no-wrap">{{ 'Total Gift' }}</span>
                                    <div class="d-flex align-center text-h6" :class="$mobile ? '' : 'ml-4'">
                                        <icon-base height="25" width="25" viewBox="0 0 100 225" icon-name="near">
                                            <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                        </icon-base>
                                        <span class="ml-1 mr-2"><number style="color: #43a047" :from="0" :to="giftedTotal.near" :duration="7" easing="Power4.easeOut" /></span>
                                        ($<number style="color: #43a047" :from="0" :to="giftedTotal.usd" :duration="7" easing="Power4.easeOut" />)
                                    </div>
                                </v-col>
                                <v-col>
                                    <span class="font-weight-medium text-uppercase text-subtitle-2 text-no-wrap">{{ 'Earning Stake' }}</span>
                                    <div class="d-flex align-center text-h6" :class="$mobile ? '' : 'ml-4'">
                                        <icon-base height="25" width="25" viewBox="0 0 100 225" icon-name="near">
                                            <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                        </icon-base>
                                        <span class="ml-1 mr-2"><number style="color: #43a047" :from="0" :to="earningRewards.near" :duration="7" easing="Power4.easeOut" /></span>
                                        ($<number style="color: #43a047" :from="0" :to="earningRewards.usd" :duration="7" easing="Power4.easeOut" />)
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>

                <v-container>
                    <v-subheader v-if="!$mobile">
                        <bnft-near-wallet-button :contractId="VUE_APP_NEAR_WISHLIST_CONTRACT_ID" v-model="wallet" class="mr-2"></bnft-near-wallet-button>
                    </v-subheader>
                    <bnft-wishlist-gift-receipt-alert v-model="giftReceiptAlert" @input="giftReceiptAlert = !giftReceiptAlert"></bnft-wishlist-gift-receipt-alert>
                    <v-row>
                        <v-col :cols="12" id="main">
                            <v-row class="d-flex">
                                <v-col :cols="12" id="table" :class="$mobile ? 'px-0' : ''">
                                    <bnft-wishlist-data-table :noNickname="noNickname" @support="supportEventHandler" :value="
                                            wishlist
                                        "></bnft-wishlist-data-table>
                                </v-col>
                                <v-subheader v-if="total > 0" inset class="text-caption font-italic text-uppercase">End of list</v-subheader>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <bnft-wishlist-support-dialog v-model="supportDialog" @cancel="supportDialog = false" :wishlist="wishlist" :supportItem="supportItem"></bnft-wishlist-support-dialog>
        
    </v-container>
</template>
<style scoped></style>
<script>
import BN from 'bn.js';
import Vue from 'vue';
import VueNumber from '@667/vue-number-animation';
import IconB from './IconB.vue';
import IconBase from './IconBase.vue';
import IconNear from '../components/IconNear.vue';
import BnftWishlistDataTable from './BnftWishlistDataTable.vue';
import BnftNearWalletButton from './BnftNearWalletButton.vue';
import BnftWishlistGiftReceiptAlert from './BnftWishlistGiftReceiptAlert.vue';
import BnftWishlistSupportDialog from './BnftWishlistSupportDialog.vue';

const { VUE_APP_NEAR_WISHLIST_CONTRACT_ID } = process.env;

Vue.use(VueNumber);

export default {
    name: 'BnftWishlist',
    components: {
        IconBase,
        IconB,
        IconNear,
        BnftWishlistDataTable,
        BnftNearWalletButton,
        BnftWishlistGiftReceiptAlert,
        BnftWishlistSupportDialog,
    },
    props: {
        id: String,
    },
    data: function () {
        return {
            VUE_APP_NEAR_WISHLIST_CONTRACT_ID,
            name: 'raWishList™',
            prompt: 'Bra Wish List',
            subprompt:
                'A wish list for all of her bra needs, wants, and desires.',
            wishlist: undefined,
            itemBalances: undefined,
            supportDialog: false,
            supportItem: null,
            wallet: null,
            gifted: {},
            accountId: null,
            currency: {
                default: 'near',
                current: 'usd',
            },
            giftReceiptAlert: false,
            paidGifts: null,
            noNickname: false,
        };
    },
    watch: {
        itemBalances(values) {
            for (const balanceTuple of values) {
                const { item_id: itemId } = balanceTuple[0];
                const amount = balanceTuple[1];
                const index = this.wishlist.items.findIndex(
                    (item) => item.id.gtin === itemId
                );
                if (index !== -1) {
                    this.$set(this.wishlist.items[index], 'balance', amount);
                }
            }
        },
        async wallet(wallet) {
            this.accountId = wallet ? await wallet.getAccountId() : undefined;
        },
    },
    mounted() {
        const self = this;
        self.noNickname = self.$route.query?.nn ? true : false;
        (async () => {
            try {
                self.get();
                self.giftReceiptAlert = this.$route.query?.transactionHashes ? true : false;
            } catch (error) {
                console.error(error);
                return error;
            }
        })();
    },
    computed: {
        src() {
            return this.supportItem?.media?.[0]?.url;
        },
        uniqueItemId() {
            return this.supportItem?.uniqueId;
        },
        total() {
            return this.wishlist?.items?.length;
        },
        username() {
            const username = this.wishlist?.owner
                ? this.$near.parseUsername(this.wishlist.owner)
                : '';
            return this.$mobile && username
                ? username.firstLastPlural
                : username.plural;
        },
        giftedTotal() {
            const total = this.gifted?.total?.reduce(
                (total, cur) => total.add(new BN(cur.amount)),
                new BN(0)
            );
            if (!total) return 0;
            const formatted = this.$near.utils.format.formatNearAmount(
                total
            );
            return {
                near: formatted,
                usd: this.$near.convertToUSD(formatted)
            };
        },
        giftedThisWishlist() {
            if (!this.gifted?.thisWishlist) return 0;
            const formatted = this.$near.utils.format.formatNearAmount(
                this.gifted?.thisWishlist
            );
            return {
                near: formatted,
                usd: this.$near.convertToUSD(formatted)
            };
        },
        earningRewards() {
            if (!this.gifted?.staked) return 0;
            const formatted = this.$near.utils.format.formatNearAmount(
                this.gifted?.staked
            );
            return {
                near: formatted,
                usd: this.$near.convertToUSD(formatted)
            };
        },
    },
    methods: {
        // Log the user in
        login() {
            this.$auth.loginWithRedirect();
        },
        // Log the user out
        logout() {
            this.$auth.logout({
                returnTo: window.location.origin,
            });
        },
        async get() {
            this.wishlist = await this.$backend.sharedWishlist({
                wishlist_id: this.id,
            });
            const ids = this.wishlist.items.map((item) =>
                this.$near.uniqueId(this.wishlist.id, item.id.gtin)
            );
            this.$near
                .wishlist({
                    functionName: 'wishlist_item_balances',
                    contractArgs: {
                        ids,
                    },
                })
                .then((balances) => {
                    this.$set(this, 'itemBalances', balances);
                });
            this.paidGifts = await this.$near.wishlist({
                functionName: 'paid_gifts'
            });
            if (this.accountId) this.$near
                .wishlist({
                    functionName: 'gifted_amount',
                    contractArgs: {
                        account_id: this.accountId,
                    },
                })
                .then((gifted) => {
                    this.gifted = { total: gifted };
                    this.gifted.perWishlist = this.gifted.total.reduce((total, cur) => {
                        total.add(new BN(cur.amount));
                        return total;
                    }, new BN(0));
                    this.gifted.thisWishlist = this.gifted.total.filter(
                        (gifted) =>
                            gifted?.id?.wishlist_id === this.id &&
                            this.wishlist.items.find(
                                (item) => item.id.gtin === gifted?.id?.item_id
                            )
                    ).reduce((total, cur) => (total.add(new BN(cur.amount))), new BN(0));
                    this.gifted.staked = this.gifted.total.reduce((staked, cur) => {
                        if (!this.paidGifts.find(paidGift => paidGift.id.item_id === cur.id.item_id)) {
                            staked = staked.add(new BN(cur.amount));
                        }
                        return staked;
                    }, new BN(0));
                });
            return this.wishlist;
        },
        supportEventHandler(item) {
            this.supportDialog = true;
            this.supportItem = item;
        },
    },
};
</script>
